import { minutesToTime } from '../catalog/format'

export function clientName(client: { first_name: string; last_name: string | null } | null): string {
  if (!client) {
    return 'No client'
  }
  return client.last_name ? `${client.first_name} ${client.last_name}` : client.first_name
}

export function timeRange(a: { start_minute: number; end_minute: number }): string {
  return `${minutesToTime(a.start_minute)}–${minutesToTime(a.end_minute)}`
}
